import { FC, SVGAttributes } from 'react';

const FillAccount: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10 26H38L43.5528 37.1056C44.2177 38.4354 43.2507 40 41.7639 40H6.23607C4.7493 40 3.78231 38.4354 4.44721 37.1056L10 26Z" fill="#C9F5DE" />
      <path d="M7.75 30.5L9 28H39L40.25 30.5H7.75Z" fill="#A3E9C3" />
      <path d="M5 36L6.5 33H41.5L43 36H5Z" fill="#A3E9C3" />
      <path d="M10 10C10 8.89543 10.8954 8 12 8H36C37.1046 8 38 8.89543 38 10V26H10V10Z" fill="#83D6A9" />
      <path
        d="M14 12.75C14 12.3358 14.3358 12 14.75 12H18.25C18.6642 12 19 12.3358 19 12.75V16.25C19 16.6642 18.6642 17 18.25 17H14.75C14.3358 17 14 16.6642 14 16.25V12.75Z"
        fill="#1CA45B"
      />
      <circle cx="36" cy="27" r="8" fill="#FFE357" />
      <path
        d="M41 26.1644H40L40.5833 24H39.037L38.5648 26.1644H37.3981L36.8796 24H35.2037L34.6944 26.1644H33.5185L33.0463 24H31.4167L32 26.1644H31V27.3411H32.3148L33.3056 31H34.8333L36 26.1558L37.1667 31H38.6944L39.6852 27.3411H41V26.1644ZM33.7778 27.3411H34.4074L34.0833 28.7239L33.7778 27.3411ZM38.0093 28.7497L37.6759 27.3411H38.3148L38.0093 28.7497Z"
        fill="white"
      />
    </svg>
  );
};

export default FillAccount;
